import React, { useState } from 'react'
import { Panel, Message, Row } from 'rsuite'
import SelectedExpertList from './selecedExpertList/SelectedExpertList'
import SeachExpert from './seachExpert/SeachExpert'
import { useHistory, useParams } from 'react-router-dom'
import pathname from '../../constants/pathname'
import SeachExpertFromAI from './seachExpert/SeachExpertFromAI'
import SeachExpertNewer from './seachExpert/SeachExpertNewer'

export default function SelectedExpert({
  schema,
  selectedExpert,
  onClickSelectExpert = () => {},
  onClickOnlineExpert = () => {},
  isSubProject,
  nextEnable = true,
  noButton,
  onChangeReviewType = () => {},
}) {
  let history = useHistory()

  const [isOpenSearchExpert, setIsOpenSearchExpert] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  return (
    <>
      <Panel
        shaded
        header={formSchema.ReviewerSelectedList?.header}
        bordered
        collapsible
        defaultExpanded
      >
        {formSchema.BudgetInfo && <span>{formSchema.BudgetInfo?.header} {`${formSchema.BudgetInfo?.budget.toLocaleString()} บาท`}</span>}
        <div>
          <Message
            showIcon
            type="warning"
            description={`ต้องการผู้ทรงคุณวุฒิ${formSchema.ReviewerSelectedList?.conditionOfReviewer?.conditionDesc}`}
          />
        </div>
        <SelectedExpertList
          schema={formSchema.ReviewerSelectedList}
          selectedExpert={selectedExpert}
          onClick={() => {
            setIsOpenSearchExpert(!isOpenSearchExpert)
          }}
          nextEnable={nextEnable}
          onNextClick={() => history.push(`${pathname.proposal.review.sendAssign}`)}
          noButton={noButton}
          onDelete={(item) => onClickSelectExpert(null, false, item)}
          onChangeReviewType={onChangeReviewType}
        />
      </Panel>

      {isOpenSearchExpert && (
        <>
          <br />
          <SeachExpertFromAI
            schema={formSchema.ReviewerAssignList}
            isSubProject={isSubProject}
            selectedExpert={selectedExpert}
            onClickSelect={onClickSelectExpert}
            onClickOnline={onClickOnlineExpert}
            countReviewerRequired={formSchema.ReviewerSelectedList?.conditionOfReviewer?.countOfReviewer}
          />
          <br />
          <SeachExpertNewer
            schema={formSchema.ReviewerAssignList}
            isSubProject={isSubProject}
            selectedExpert={selectedExpert}
            onClickSelect={onClickSelectExpert}
            onClickOnline={onClickOnlineExpert}
          />
          <br />
          <Panel
            shaded
            header={formSchema?.headerSummary || 'ค้นหาผู้ทรงคุณวุฒิ'}
            bordered
            collapsible
            defaultExpanded
          >
            <SeachExpert
              schema={formSchema.ReviewerAssignList}
              isSubProject={isSubProject}
              selectedExpert={selectedExpert}
              onClickSelect={onClickSelectExpert}
              onClickOnline={onClickOnlineExpert}
            />
          </Panel>
        </>
      )}
      <br />
    </>
  )
}
